import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { ContactCreationRequestDto, ContactCreationResponseDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Req = {
  dto: ContactCreationRequestDto;
};

type Return = {
  createContact: (req: Req) => Promise<ContactCreationResponseDto>;
  isCreatingContact: boolean;
};

export const useCreateContact = (): Return => {
  const { contactsApi } = useApiClient();
  const { userId } = useUserContext();

  const { isPending, mutateAsync } = useMutation<ContactCreationResponseDto, AxiosError, Req>({
    mutationFn: async req => {
      const res = await contactsApi.createContact(userId, req.dto);

      return res.data;
    },
    mutationKey: [QueryKeyEnum.CONTACTS.CREATE],
  });

  return {
    createContact: mutateAsync,
    isCreatingContact: isPending,
  };
};
